import { render } from "./wallet-card.vue?vue&type=template&id=9fa92dec&scoped=true"
import script from "./wallet-card.vue?vue&type=script&lang=js"
export * from "./wallet-card.vue?vue&type=script&lang=js"

import "./wallet-card.vue?vue&type=style&index=0&id=9fa92dec&lang=scss&scoped=true"
import "./wallet-card.vue?vue&type=style&index=1&id=9fa92dec&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa92dec"]])

export default __exports__